import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { EditableElements, EditableTrueType } from 'redux/schemas/models/edit-translations';
import { LectureComponent } from 'redux/schemas/models/lecture-component';
import { CourseOutlineItem } from 'redux/selectors/course-outline/course-outline-item';
import { addAlertMessage } from 'redux/actions/alert-messages';
import { AlertMessageType } from 'redux/schemas/app/alert-message';
import t from 'react-translate';

type TranslationComponent = {
  type: EditableElements,
  trueType?: EditableTrueType,
  component: LectureComponent | CourseOutlineItem,
};

export const showEditTranslationComponent = createAction<TranslationComponent>('SHOW_EDIT_TRANSLATION_COMPONENT');
export const closeEditTranslationComponent = createAction('CLOSE_EDIT_TRANSLATION_COMPONENT');

type FileReplacementParameters = {
  lectureComponentId: number,
  attachmentId: number,
  attachment,
  catalogId,
  language,
};

export const translatedFileReplacement = createAsyncThunk(
  'TRANSLATED_FILE_REPLACEMENT',
  async (params: FileReplacementParameters, thunkAPI) => axios.post(
    `${params.catalogId}/attachments/${params.attachmentId}/create_manual_translation`,
    {
      attachment: params.attachment,
      language: params.language,
    },
  ).then(res => res.data.result)
    .catch(() => {
      thunkAPI.dispatch(addAlertMessage({
        type: AlertMessageType.ERROR,
        header: t.AUTOMATED_TRANSLATION.ERROR(),
        message: t.AUTOMATED_TRANSLATION.RETRY(),
      }));
    }),
);
